/**
 * @category  ScandiPWA
 * @author    Kristers Cams <kristers.cams@scandiweb.com | info@scandiweb.com>
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 * @copyright Copyright (c) 2021 Scandiweb, Inc (https://scandiweb.com)
 */

import { Field } from 'Util/Query';

/** @namespace ScandipwaAmastyLabels/Query/ProductLabelSetting/Query */
export class ProductLabelSettingQuery {
    getQuery() {
        return new Field('amLabelSetting')
            .addFieldList(['product_container', 'category_container', 'max_labels',
                'show_several_on_place', 'labels_alignment', 'margin_between']);
    }
}

export default new ProductLabelSettingQuery();
